import { UpdateTenantProductPayload } from "@surgia/ui/dtos/request";
import { apiClient } from "../client";

export interface ProductPrice {
  price: number;
  currency: string;
}

export interface AssignTenantProductVariantPayload {
  productIds: number[];
  parentProductId: number;
}

export interface AssignParentProductsPayload {
  parentProductIds: number[];
}

export interface UpdateCustomerViewPayload {
  customerView: boolean;
}

export const updateTenantProduct = async (
  tenantProductId: string,
  payload: UpdateTenantProductPayload
): Promise<any> => {
  const response = await apiClient.put(
    `/corporate/v1/tenant-products/${tenantProductId}`,
    payload
  );
  return response.data;
};

export const updateTenantProductCustomerView = async (
  tenantProductId: string,
  payload: UpdateCustomerViewPayload
): Promise<any> => {
  const response = await apiClient.put(
    `/corporate/v1/tenant-products/${tenantProductId}/view`,
    payload
  );
  return response.data;
};

export const getProductVariations = async (
  parentProductId: string,
  tenantId: string
): Promise<any> => {
  const response = await apiClient.get(
    `/corporate/v1/tenant-products/${parentProductId}/variations?tenant_id=${tenantId}`
  );
  return response.data;
};

export const assignProductVariant = async (
  tenantId: string,
  payload: AssignTenantProductVariantPayload
): Promise<any> => {
  const response = await apiClient.post(
    `/corporate/v1/tenant-products/variations?tenant_id=${tenantId}`,
    payload
  );
  return response.data;
};

export const assignParentProducts = async (
  tenantId: string,
  payload: AssignParentProductsPayload
): Promise<any> => {
  const response = await apiClient.post(
    `/corporate/v1/tenant-products?tenant_id=${tenantId}`,
    payload
  );
  return response.data;
};

